import React from 'react';

export default function CyborgVisorGreenSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="33.54,26.4 3.79,26.4 3.79,14.5 33.54,14.5" fill="#272B2B" />
      <polygon points="3.79,26.4 33.54,26.4 31.75,25.5 2.0,25.5" fill="#000000" opacity="0.95" />
      <polygon points="3.79,26.4 2.0,25.5 2.0,13.6 3.79,14.5" fill="#000000" opacity="0.95" />
      <polygon points="38.0,25.65 35.02,25.65 35.02,16.73 38.0,16.73" fill="#272B2B" />
      <polygon points="35.02,25.65 38.0,25.65 33.54,23.42 30.56,23.42" fill="#000000" opacity="0.95" />
      <polygon points="35.02,25.65 30.56,23.42 30.56,14.5 35.02,16.73" fill="#000000" opacity="0.95" />
      <polygon points="11.22,25.65 8.25,25.65 8.25,16.73 11.22,16.73" fill="#272B2B" />
      <polygon points="8.25,25.65 11.22,25.65 6.76,23.42 3.79,23.42" fill="#000000" opacity="0.95" />
      <polygon points="8.25,25.65 3.79,23.42 3.79,14.5 8.25,16.73" fill="#000000" opacity="0.95" />
    </svg>
  );
}
